import { render, staticRenderFns } from "./FeeChipGroup.vue?vue&type=template&id=36ab222b&"
import script from "./FeeChipGroup.vue?vue&type=script&lang=js&"
export * from "./FeeChipGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VChipGroup,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ab222b')) {
      api.createRecord('36ab222b', component.options)
    } else {
      api.reload('36ab222b', component.options)
    }
    module.hot.accept("./FeeChipGroup.vue?vue&type=template&id=36ab222b&", function () {
      api.rerender('36ab222b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Invoicing/FeeChipGroups/FeeChipGroup.vue"
export default component.exports